import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
	selector: 'ic-icon-detail',
	templateUrl: './icon-detail.component.html',
	styleUrls: ['./icon-detail.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class IconDetailComponent {
	@Input() icon: string;
}
